<template>
    <div class="container">
        <form class="form" v-on:submit.prevent="profileSubmit" v-if="user">
            <h2 class="form-heading">{{langMyProfileEdit.profile[locale]}}</h2>
        
            <fieldset :disabled="!profile.editing">
                <form-input :labelText="langMyProfileEdit.name[locale]" :placeholder="langMyProfileEdit.name[locale]" v-model="user.name" :required="true" :tooltipTitle="langMyProfileEdit.nameToolTip[locale]"/>
                <form-input :labelText="langMyProfileEdit.email[locale]" :placeholder="langMyProfileEdit.email[locale]" v-model="user.email" :inputType="'email'" :required="true" :tooltipTitle="langMyProfileEdit.emailToolTip[locale]"/>
                <form-select :labelText="langMyProfileEdit.selectARole[locale]" v-model="user.role" :options="[{text: langMyProfileEdit.selectARole[locale], value: ''}, {text: langMyProfileEdit.individual[locale], value: 'individual'}, {text: langMyProfileEdit.store[locale], value: 'store'}]" :allowedValues="['individual', 'store']" :required="true" :tooltipTitle="langMyProfileEdit.selectARoleToolTip[locale]"/>
                <form-input :labelText="langMyProfileEdit.phone[locale]" :placeholder="langMyProfileEdit.phone[locale]" v-model="user.phone" :required="true" :tooltipTitle="langMyProfileEdit.phoneToolTip[locale]"/>

                <form-select :labelText="langMyProfileEdit.selectAProvince[locale]" v-model="user.province" :options="[{text: langMyProfileEdit.selectAProvince[locale], value: null}].concat(PROVINCES.map(item => {return {value: item, text: item}}))" :allowedValues="PROVINCES" :required="true" :tooltipTitle="langMyProfileEdit.selectAProvinceToolTip[locale]"/>
                <form-select :labelText="langMyProfileEdit.selectACity[locale]" v-model="user.city" :disabled="!user.province" :options="[{text: langMyProfileEdit.selectACity[locale], value: null}].concat(CITIES.map(item =>{if(user.province === item.Maakunta) return {text: item.Kunta, value: item.Kunta};}).filter(item => !!item))" :allowedValues="CITIES.map(item =>{if(user.province === item.Maakunta) return item.Kunta;}).filter(item => !!item)" :required="true" :tooltipTitle="langMyProfileEdit.selectACity[locale]"/>
                <form-input v-if="user.role === 'store'" :labelText="langMyProfileEdit.address[locale]" :placeholder="langMyProfileEdit.address[locale]" v-model="user.address" :required="true" :tooltipTitle="langMyProfileEdit.addressToolTip[locale]"/>
                <form-input :labelText="langMyProfileEdit.website[locale]" :placeholder="langMyProfileEdit.website[locale]" v-model="user.website" :inputType="'url'" :tooltipTitle="langMyProfileEdit.websiteToolTip[locale]"/>
                
                <nettipyora-button v-if="user.role === 'store'" :text="langMyProfileEdit.addMoreContacts[locale]" :className="'btn-outline-secondary'" :clickHandler="addMoreContacts" />
                <br />
                <br />
                <div class="more-contacts" v-for="(contact, n) in user.contacts" :key="n">
                    <form-input :labelText="langMyProfileEdit.name[locale]" :placeholder="langMyProfileEdit.name[locale]" v-model="contact.name" :required="true" :tooltipTitle="langMyProfileEdit.nameToolTip[locale]"/>
                    <form-input :labelText="langMyProfileEdit.email[locale]" :placeholder="langMyProfileEdit.email[locale]" v-model="contact.email" :inputType="'email'" :required="true" :tooltipTitle="langMyProfileEdit.emailToolTip[locale]"/>
                    <form-input :labelText="langMyProfileEdit.phone[locale]" :placeholder="langMyProfileEdit.phone[locale]" v-model="contact.phone" :required="true" :tooltipTitle="langMyProfileEdit.phoneToolTip[locale]"/>
                    <form-check-boxes :labelText="langMyProfileEdit.selectLanguages[locale]" v-model="contact.languages" :options="[{text:'EN', value:'EN'}, {text:'FI', value:'FI'}, {text:'SV', value:'SV'}]"/>
                    <font-awesome-icon v-if="profile.editing" style="cursor: pointer; color: red; font-size: 25px; position: absolute; top: 0px; right: -20px;" icon="times-circle" v-on:click.stop="user.contacts.splice(n, 1)"/>
                </div>
                <div v-if="user.contacts">
                    <br v-if="user.contacts.length > 0 && user.role === 'store'" />
                </div>
            </fieldset>
           
            <button type="button" class="btn btn-secondary" v-if="!profile.editing" @click.stop.prevent="$store.commit('MY_PROFILE_EDIT_EDITING', true)">{{langMyProfileEdit.edit[locale]}}</button>
            <button type="button" class="btn btn-danger" style="margin-right: 0.5em" v-if="profile.editing" @click.stop.prevent="profileReset">{{langMyProfileEdit.cancel[locale]}}</button>
            <nettipyora-button :text="langMyProfileEdit.save[locale]" style="margin-left: 0.5em" :loading="profile.loading" :disabled="getChangedObjKeys.length < 1" :className="'btn-primary'" :submit="true" v-if="profile.editing"/>
        </form>
        <div class="container" v-else>
            <font-awesome-icon style="margin: 1em" class="spinner" size="2x" icon="circle-notch" :spin="true"/>
        </div>
        <br />
        <b-alert :variant="profile.statusOk ? 'success':'danger'" :show="!!profile.okMessage || !!profile.errMessage" >{{profile.okMessage || profile.errMessage}}</b-alert>
        <hr />
        
        <form class="form" v-on:submit.prevent="passwordSubmit">
            <h2 class="form-heading">{{langMyProfileEdit.changePassword[locale]}}</h2>
            <form-input :labelText="langMyProfileEdit.currentPassword[locale]" :placeholder="langMyProfileEdit.currentPassword[locale]" v-model="credential.currentPassword" :inputType="'password'" :required="true" :tooltipTitle="langMyProfileEdit.currentPasswordToolTip[locale]" :extraValidation="credential.currentPassword.length > 0"/>
            <form-input :labelText="langMyProfileEdit.newPassword[locale]" :placeholder="langMyProfileEdit.newPassword[locale]" v-model="credential.newPassword" :inputType="'password'" :required="true" :tooltipTitle="langMyProfileEdit.newPasswordToolTip[locale]" :extraValidation="credential.newPassword.length > 0"/>
            <form-input :labelText="langMyProfileEdit.confirmNewPassword[locale]" :placeholder="langMyProfileEdit.confirmNewPassword[locale]" v-model="credential.confirmNewPassword" :inputType="'password'" :required="true" :tooltipTitle="langMyProfileEdit.confirmNewPasswordToolTip[locale]" :extraValidation="credential.newPassword === credential.confirmNewPassword"/>
            
            <b-alert :variant="password.statusOk ? 'success':'danger'" :show="!!password.okMessage || !!password.errMessage" >{{password.okMessage || password.errMessage}}</b-alert>

            <nettipyora-button :text="langMyProfileEdit.change[locale]" :loading="password.changing" :className="'btn-primary'" :submit="true" />
        </form>
        <br />
    </div>
</template>

<script>
/* eslint-disable no-console */
// @ is an alias to /src
import { getDiffObjKeys } from '@/store/constant';
import NettipyoraButton from '@/components/NettipyoraButton.vue';
import FormInput from '@/components/FormInput';
import FormSelect from '@/components/FormSelect';
import FormCheckBoxes from '@/components/FormCheckBoxes';
import { mapState } from 'vuex';
import { EMAIL_REGEX, URL_REGEX, PROVINCES, CITIES } from '@/store/constant';
import langMyProfileEdit from '@/store/lang/myProfileEdit';

export default {
    name: 'MyProfileEdit',
    components: {
        NettipyoraButton, FormInput, FormSelect, FormCheckBoxes
    },
    computed: {
        ...mapState({
            profile: state => state.MyProfileEdit.profile,
            password: state => state.MyProfileEdit.password,
            authenticatedUser: state => state.authenticatedUser,
            locale: state => state.locale
        }),
        getChangedObjKeys() {
            const diff = getDiffObjKeys(this.authenticatedUser, this.user);
            return diff;
        }
    },
    watch: {
        authenticatedUser() {
            this.user = JSON.parse(JSON.stringify(this.authenticatedUser));
        }
    },
    data() {
        return {
            langMyProfileEdit, PROVINCES, CITIES,
            emailRegex: EMAIL_REGEX,
            urlRegex: URL_REGEX,
            user: {},
            credential: {
                currentPassword: "",
                newPassword: "",
                confirmNewPassword: ""
            },
            //image: {}
        }
    },
    mounted() {
        this.user = JSON.parse(JSON.stringify(this.authenticatedUser));
    },
    methods: {
/*
        userImageChange() {
            const self = this;
            const files = self.$refs.userImage.files;
            self.contentType = files[0].type;
            self.image = {
                URI: URL.createObjectURL(files[0]), 
                file: files[0]
            };
        },
        submitClicked() {
            const self = this;
            if(self.authenticatedUser.imageURI) {
                const suffix = self.authenticatedUser.imageURI.split('/')[self.authenticatedUser.imageURI.split('/').length-1];
                console.log("suffix", suffix);
                self.image.name = suffix;
            }
            self.$store.commit('MY_PROFILE_EDIT_LOADING', true);
            if(self.image.URI && self.image.file) self.singeFileUploader(self.image).then(url => {
                self.user.imageURI = url;
                self.profileSubmit();
            }).catch(err => {
                console.log(err);
                self.$store.commit('MY_PROFILE_EDIT_LOADING', false);
                self.$store.commit('MY_PROFILE_EDIT_ERROR', "Profile failed to update");
            });
            else self.profileSubmit();
        },
*/
        profileSubmit() {
            let payload;
            this.getChangedObjKeys.forEach(key => {
                if(payload) payload[key] = this.user[key];
                else payload = {[key]: this.user[key]};
            });
            /*
            for(let key in this.user) {
                if(this.authenticatedUser[key] !== this.user[key] && ["followers", "following", "reviews"].indexOf(key) < 0) {
                    if(payload) payload[key] = this.user[key];
                    else payload = {[key]: this.user[key]};
                }
            }*/
            if(payload) this.$store.dispatch('MY_PROFILE_EDIT_SAVE', payload);
        },
        passwordSubmit() {
            if(this.credential.currentPassword.length < 4) {
                return this.$store.commit('MY_PROFILE_EDIT_PASSWORD_ERROR', "Current password must be greater than 7 characters");
            }
            if(this.credential.newPassword.length < 8) {
                return this.$store.commit('MY_PROFILE_EDIT_PASSWORD_ERROR', "New password must be greater than 7 characters");
            }
            if(this.credential.newPassword === this.credential.currentPassword) {
                return this.$store.commit('MY_PROFILE_EDIT_PASSWORD_ERROR', "New password must be different from current password");
            }
            if(this.credential.newPassword !== this.credential.confirmNewPassword) {
                return this.$store.commit('MY_PROFILE_EDIT_PASSWORD_ERROR', "New password and confirm new password are not matching");
            }

            this.$store.dispatch('MY_PROFILE_EDIT_CHANGE_PASSWORD', JSON.parse(JSON.stringify(this.credential)));
            this.credential = {
                currentPassword: "",
                newPassword: "",
                confirmNewPassword: ""
            };
        },
        addMoreContacts() {
            const self = this;
            self.user.contacts.push({
                name: "",
                email: "",
                phone: "",
                languages: []
            });
        },
        profileReset() {
            this.user = JSON.parse(JSON.stringify(this.authenticatedUser));
            this.$store.commit('MY_PROFILE_EDIT_EDITING', false);
        }
    }
}
</script>

<style scoped>
.label {
    font-size: 0.8em;
    display: block;
    margin: 0;
    margin-left: 10px;
}

#user-image-input {
    width:0;
    height: 0;
    visibility: hidden;
}
.form-control img {
    cursor: pointer;
}
.form {
    max-width: 800px;
    margin: auto;
}
.more-contacts {
    max-width: 500px;
    padding: 15px;
    margin: 0 auto;
    position: relative;
}
select:not([multiple]) {
    -webkit-appearance: none;
    -moz-appearance: none;
    background-position: right 50%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDZFNDEwNjlGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDZFNDEwNkFGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0NkU0MTA2N0Y3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0NkU0MTA2OEY3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuGsgwQAAAA5SURBVHjaYvz//z8DOYCJgUxAf42MQIzTk0D/M+KzkRGPoQSdykiKJrBGpOhgJFYTWNEIiEeAAAMAzNENEOH+do8AAAAASUVORK5CYII=);
    padding-right: 1.5em
}
.checkbox-inline {
    margin-left: 10px;
    margin-right: 10px;
}
.checkbox-inline input {
    margin: 5px;
}
</style>
